import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  Table, TableHeader, TableRow, TableHeaderColumn, TableBody, TableRowColumn, RaisedButton,
  Card, CardText, CardHeader, Drawer, CircularProgress, TableFooter,
} from "material-ui";
import styles from "../../styles/styles";
import TablePaginationCustom from "../../TablePagination/view";
import DetalleErroresSE from "./DetalleErrores";
import ResolucionSolicitudSE from "./ResolucionSolicitud";
import { ObtenerSolicitudes, BuscarErrores } from "../FiltroBusqueda/actions";
import { PermiteReplicarSolicitud } from "../../ActualizarArancel/ReplicarSolicitud/actions";


class GrillaSolicitudesSE extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalDetalleSolicitud: false,
      modalDetalleErrores: false,
      datosSolicitudSelect: null,
    };
  }

  componentWillMount() {
    this.ObtenerSolicitudes();
    this.props.dispatch(PermiteReplicarSolicitud());
  }

  VerDetalleSolicitud = (datosSolicitud) => {
    this.setState({ datosSolicitudSelect: datosSolicitud });
    this.setState({ modalDetalleSolicitud: true });
  }

  VerDetalleErrores = (idSolicitudEspecial) => {
    this.props.dispatch(BuscarErrores(idSolicitudEspecial));
    this.setState({ modalDetalleErrores: true });
  }

  ObtenerSolicitudes = () => {
    this.props.dispatch(ObtenerSolicitudes());
  }

  render() {
    const menuListsolicitudes = [];

    this.props.solicitudes.forEach((row, index) => {
      const mostrarSolicitud = row.IdSolicitud && row.IdSolicitud > 0 && row.IdEstadoSE != 50;
      const mostrarErrores = row.IdEstadoSE === 54 || row.IdEstadoSE === 50;
      menuListsolicitudes.push((
        <TableRow
          key={`tablaRowGrillaSolicitudPrestaciones_${index}`}
        >
          <TableRowColumn>{row.IdSolicitudEspecial}</TableRowColumn>
          <TableRowColumn>{row.FechaCreacion}</TableRowColumn>
          <TableRowColumn>{row.EstadoSE}</TableRowColumn>
          <TableRowColumn>
            {mostrarSolicitud ?
              <RaisedButton
                onClick={() => this.VerDetalleSolicitud(row)}
                label="Ver Solicitud"
                secondary
                labelStyle={{ fontSize: "11px" }}
                overlayStyle={{ borderRadius: 5 }}
                rippleStyle={{ borderRadius: 5 }}
                style={{ width: "150px", borderRadius: 5, marginLeft: 20 }}
                buttonStyle={{ borderRadius: 5 }}
                icon={<i className="material-icons" style={{ color: "#ffffff" }}>description</i>}
              >
              </RaisedButton>
              : null}
            {!mostrarSolicitud && mostrarErrores ?
              <RaisedButton
                onClick={() => this.VerDetalleErrores(row.IdSolicitudEspecial)}
                label="Ver errores"
                secondary
                labelStyle={{ fontSize: "11px" }}
                overlayStyle={{ borderRadius: 5 }}
                rippleStyle={{ borderRadius: 5 }}
                style={{ width: "150px", borderRadius: 5, marginLeft: 20 }}
                buttonStyle={{ borderRadius: 5 }}
                icon={<i className="material-icons" style={{ color: "#ffffff" }}>error</i>}
              >
              </RaisedButton>
              : null}
            {!mostrarSolicitud && !mostrarErrores ?
              <CircularProgress style={{ marginLeft: "20px", width: "10px" }}></CircularProgress>
              : null}
          </TableRowColumn>
        </TableRow>
      ));
    });

    /* const solicitudesForInterval = this.props.solicitudes
    const ObtenerSolicitudesForInterval = this.ObtenerSolicitudes
    let checkForValidatingRows = setInterval(function () {
      if (solicitudesForInterval && solicitudesForInterval.length > 0) {
        const isValidatingRows = solicitudesForInterval.filter(s => {
          const mostrarSolicitud = s.IdSolicitud && s.IdSolicitud > 0;
          const mostrarErrores = s.IdEstadoSE === 54 || s.IdEstadoSE === 50;

          if (!mostrarSolicitud && !mostrarErrores) return s
        }).length > 0

        if (isValidatingRows) {
          console.log("helloooooooo!!")
          ObtenerSolicitudesForInterval()
        } else clearInterval(checkForValidatingRows)
      }
    }, 10000) */

    return (
      <div>
        <div style={{ padding: "5px" }}>
          <Card
            initiallyExpanded
            zDepth={0}
          >
            <CardHeader
              actAsExpander
              showExpandableButton
              style={{
                paddingTop: "0px", paddingBottom: "0px", maxWidth: "990px",
              }}
            >
              <div style={styles.h1}>Archivos Enviados</div>
            </CardHeader>
            <CardText
              expandable
              style={{
                paddingTop: "0px", paddingBottom: "0px", maxWidth: "990px", overflow: "auto",
              }}
            >
              {(!this.props.solicitudes || this.props.solicitudes.length === 0) ?
                <span style={{ textAlign: "center" }}>No se encontraron solicitudes</span>
                :
                <div>
                  {this.props.loadingSolicitudes ?
                    <CircularProgress></CircularProgress> :
                    <Table
                      key="tablaGrillaSolicitudesEnviadas"
                      fixedHeader
                      selectable={false}
                      style={{ overflow: "hidden" }}
                    >
                      <TableHeader adjustForCheckbox={false} displaySelectAll={false} >
                        <TableRow selectable={false}>
                          <TableHeaderColumn style={styles.tituloTabla1}>ID Envío</TableHeaderColumn>
                          <TableHeaderColumn style={styles.tituloTabla1}>Fecha de envío</TableHeaderColumn>
                          <TableHeaderColumn style={styles.tituloTabla2}>Estado</TableHeaderColumn>
                          <TableHeaderColumn style={styles.tituloTabla3}>Detalle</TableHeaderColumn>
                        </TableRow>
                      </TableHeader>
                      <TableBody
                        id="tablaBodyGrillaSolicitudesEnviadas"
                        deselectOnClickaway={false}
                        displayRowCheckbox={false}
                        stripedRows
                      >
                        {menuListsolicitudes}
                      </TableBody>
                      <TableFooter>
                        <TableRow>
                          <TableRowColumn>
                            <TablePaginationCustom
                              key={`pag_tablaBodyGrillaSolicitudesEnviadas_${menuListsolicitudes.length}`}
                              rowsPerPageDefault={5} // [5,10,15,20,25]
                              totalRows={menuListsolicitudes.length}
                              pageDefault={1}
                              idTableBody="tablaBodyGrillaSolicitudesEnviadas"
                              showRowsPerPage={false}
                              labelStyleBtnPage={{ fontSize: "11px" }}
                              overlayStyleBtnPage={{ borderRadius: 20 }}
                              rippleStyleBtnPage={{ borderRadius: 20 }}
                              buttonStyleBtnPage={{ borderRadius: 20 }}
                              styleBtnPage={{
                                paddingLeft: 0,
                                paddingRight: 0,
                                paddingTop: 0,
                                paddingBottom: 0,
                                height: 25,
                                width: "45px",
                                minWidth: "45px",
                                borderRadius: 20,
                                marginRight: 5,
                              }}

                              labelStyleRowsPerPage={styles.h4}
                              underlineStyleRowsPerPage={styles.underlineSelectField}
                              iconStyleRowsPerPage={styles.iconSelectField}
                              menuItemStyleRowsPerPage={styles.menuItemStyleSelectField}
                              selectedMenuItemStyleRowsPerPage={styles.selectedMenuItemSelectField}
                              styleRowsPerPage={styles.selectFiledStyle}
                            />
                          </TableRowColumn>
                        </TableRow>
                      </TableFooter>
                    </Table>
                  }
                </div>
              }
              <div className="row text-right" >
                <div className="col-12">
                  <RaisedButton
                    onClick={this.ObtenerSolicitudes}
                    label="Refrescar"
                    secondary
                    labelStyle={{ fontSize: "11px" }}
                    overlayStyle={{ borderRadius: 5 }}
                    rippleStyle={{ borderRadius: 5 }}
                    style={{ width: "150px", borderRadius: 5, marginLeft: 20 }}
                    buttonStyle={{ borderRadius: 5 }}
                  />
                </div>
              </div>
            </CardText>
          </Card>
        </div>

        <Drawer
          width="95%"
          openSecondary
          open={this.state.modalDetalleSolicitud}
          docked={false}
        >
          {this.state.modalDetalleSolicitud ?
            <ResolucionSolicitudSE detalleSolicitud={this.state.datosSolicitudSelect} closeModal={() => this.setState({ modalDetalleSolicitud: false })} />
            : null}
        </Drawer>

        <Drawer
          width="95%"
          openSecondary
          open={this.state.modalDetalleErrores}
          docked={false}
        >
          {this.state.modalDetalleErrores ?
            <DetalleErroresSE closeModal={() => this.setState({ modalDetalleErrores: false })} />
            : null}
        </Drawer>

      </div>
    );
  }
}

GrillaSolicitudesSE.defaultProps = {
};

GrillaSolicitudesSE.propTypes = {
  solicitudes: PropTypes.array.isRequired,
  loadingSolicitudes: PropTypes.bool.isRequired,
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  solicitudes: state.filtroBusquedaSE.solicitudes,
  loadingSolicitudes: state.filtroBusquedaSE.loadingSolicitudes,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(GrillaSolicitudesSE);
